<header mat-dialog-title>
  <div *ngIf="evento$ | async as evento" class="dialog-header">
    <h3 class="mat-h2">{{accion | titlecase}} trabajo<span class="glm-modal-subtitle">{{evento.nombre}}</span></h3>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</header>

<mat-dialog-content class="modal-central-container" style="height: calc(100% - 152px);">
  <h3 class="mat-h3">Alumnos</h3>
  <mat-chip-set>
    <mat-chip *ngFor="let alumno of datosAlumnos" class="alumno-chip-ref">
      <div style="height: 32px; display:flex; align-items: center;">
        <div class="user-img-cont">
          <img [src]="alumno.imageUrl" class="user-img">
        </div>
        <label>{{alumno.apellidosNombres}}</label>
      </div>
    </mat-chip>
  </mat-chip-set>
  <div style="margin-top: 32px">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Comentario</mat-label>
      <textarea matInput
        placeholder="Recuerde añadir información no presente en la rúbrica sobre el logro de la meta y recomendaciones de mejora."
        [formControl]="mensaje"></textarea>
    </mat-form-field>
    <mat-checkbox [formControl]="email" color="primary">Notificar alumnos</mat-checkbox>
    <p class="tip-text"><small>Un correo electrónico será enviado a los alumnos seleccionados</small></p>

    <mat-divider></mat-divider>

    <form *ngIf="accion === 'publicar'" [formGroup]="configuracionForm">
      <div class="config">

        <div>
          <h3 class="mat-h3">Opciones de publicación</h3>
          <p class="config-item">
            Estas opciones afectan la visualización de la retroalimentación una vez publicada:
          </p>
          <p class="config-item">
            <mat-slide-toggle formControlName="mostrarRubrica" color="primary" disabled>Mostrar rúbrica</mat-slide-toggle>
          </p>
          <p class="config-item">
            <mat-slide-toggle formControlName="mostrarColoresEscala" color="primary" hidden='true'>
              Mostrar colores distintivos en la escala de logro
            </mat-slide-toggle>
          </p>
          <p class="config-item">
            <mat-slide-toggle formControlName="mostrarEvidenciaDetalle" color="primary">Mostrar detalle de la evidencia
            </mat-slide-toggle>
          </p>
        </div>

        <div disabled>
          <h3 class="mat-h3">Opciones de retroalimentación</h3>
          <p class="config-item">
            Estas opciones permiten exigir pasos previos a los alumnos para ver la retroalimentación:
          </p>
          <p class="config-item">
            <mat-slide-toggle formControlName="requiereAutoevaluacion" color="primary" disabled>Requiere autoevaluación de
              criterios</mat-slide-toggle>
          </p>
          <p class="config-item">
            <mat-slide-toggle formControlName="requiereAutoevaluacionComentario" color="primary" disabled>Requiere comentario de
              autoevaluación
            </mat-slide-toggle>
          </p>
          <p class="config-item">
            <mat-slide-toggle formControlName="mostrarComentarioProfesorAntes" color="primary" disabled>Los alumnos ven la
              retroalimentación sin completar su autoevaluación
            </mat-slide-toggle>
          </p>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-progress-bar *ngIf="saving$ | async" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions style="position: absolute;">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="submit(accion)"
    [disabled]="saving$ | async">{{accion | titlecase}}</button>
</mat-dialog-actions>
